<section class="page-wrapper">
   <div class="cart-top-section">
      <div class="container">
         <div class="cart-top-detail">
            <div class="red-titel">Checkout</div>
         </div>
      </div>
   </div>
   <div class="checkout-center-section cf">
      <div class="container">
         <div class="checkout-center-detail cf">
            <div class="checkout-center-detail-left">
               <div class="cart-center-detail-top cf">
                  <div class="cart-center-top cf">
                     <div class="cart-center-top-left">
                        <div class="cart-center-top-left-image">
                           <img [src]="cartList?.image">
                        </div>
                     </div>
                     <div class="cart-center-top-center">
                        <p>{{cartList?.title}} </p>
                        <h3></h3>
                     </div>
                  </div>
                  <div class="cart-center-bottom cf">
                     <div class="cart-center-bottom-general">
                        <div class="checkout-center-detail-right-general-admission-detail cf"
                           *ngFor="let cartitem of cartList?.seasonticket_general">
                           <h3>{{cartitem?.type}}</h3>
                           <div *ngFor="let cartitemassign of cartitem?.season_ticket_assign">
                              <div class="checkout-center-detail-right-general-admission-name">
                                 <p>Assigned to: {{cartitemassign?.first_name}} {{cartitemassign?.last_name}} <br><a
                                       href="">{{cartitemassign?.email}} </a> | {{cartitemassign?.account_no}}</p>
                              </div>
                              <div class="checkout-center-detail-right-general-admission-price">
                                 <p>£{{cartitemassign?.amount}}.00</p>
                              </div>
                              <div class="checkout-center-detail-right-away-fans-btn">
                                 <p><a (click)="edit_detail_popup(cartitemassign?.seasonticket_assign_id)">Edit Details</a></p>
                                 <p class="delete-img"><a (click)="delete_detail(cartitem?.user_cart_id, cartitemassign?.seasonticket_assign_id)"><img src="assets/images/delete.svg"></a></p>
                              </div>
                              <div class="login-section forlogin-section assign checkout mfp-hide"
                                 id="login-box-{{cartitemassign?.seasonticket_assign_id}}">
                                 <div class="add-popup cf">
                                    <div class="container">
                                       <div class="checkout-center-detail-popup">
                                          <h2>Add Details</h2>
                                          <!-- <p>Assign to an existing account by entering an account number and the supporter’s name.</p>
                                          <p>Alternatively, assign tickets to a new account by entering the name of the person attending.</p> -->
                                          <form #assignForm="ngForm"
                                             (ngSubmit)="updateAssign(assignForm, cartitemassign?.seasonticket_assign_id)">
                                             <input type="hidden"
                                                id="seasonticket_assign_id-{{cartitemassign?.seasonticket_assign_id}}"
                                                name="seasonticket_assign_id" value="{{cartitemassign?.seasonticket_assign_id}}">
                                             <input type="hidden" id="account_no-{{cartitemassign?.seasonticket_assign_id}}"
                                                name="account_no" value="{{cartitemassign?.account_no}}">
                                             <input type="hidden" id="first_name-{{cartitemassign?.seasonticket_assign_id}}"
                                                name="first_name" value="{{cartitemassign?.first_name}}">
                                             <input type="hidden" id="last_name-{{cartitemassign?.seasonticket_assign_id}}"
                                                name="last_name" value="{{cartitemassign?.last_name}}">
                                             <input type="hidden" id="birth_date-{{cartitemassign?.seasonticket_assign_id}}"
                                                name="birth_date" value="{{cartitemassign?.birth_date}}">
                                             <http-message types="success" [data]="assignSuccess" class="err-msg-block">
                                             </http-message>
                                             <http-message [type]="'error'" [data]="assignError" *ngIf="assignError"
                                                class="err-msg-block"></http-message>
                                             <div class="checkout-center-detail-address-box cf">
                                                <div class="checkout-address-box half">
                                                   <app-form-field validation="required" name="first_name"
                                                      [(ngModel)]="assignRequest.first_name" class="app-group">
                                                      <input appFieldInput type="text" name="" placeholder="First Name"
                                                         class="input-style">
                                                   </app-form-field>
                                                </div>
                                                <div class="checkout-address-box half">
                                                   <app-form-field validation="required" name="last_name"
                                                      [(ngModel)]="assignRequest.last_name" class="app-group">
                                                      <input appFieldInput type="text" name="" placeholder="Last Name"
                                                         class="input-style">
                                                   </app-form-field>
                                                </div>
                                                <div class="checkout-address-box full">

                                                   <app-form-field validation="required" name="account_no"
                                                      [(ngModel)]="assignRequest.account_no" class="app-group">
                                                      <input appFieldInput type="text" name="" placeholder="Account No."
                                                         class="input-style">
                                                   </app-form-field>
                                                </div>
                                                <div class="checkout-address-box full">
                                                   <app-form-field validation="required" name="birth_date"
                                                      [(ngModel)]="assignRequest.birth_date">
                                                      <input appFieldInput type="text" [min]="min" [max]="today"
                                                         class="input-style-check" name="birth_date"
                                                         [(ngModel)]="assignRequest.birth_date" readonly
                                                         [owlDateTimeTrigger]="start_date_picker"
                                                         [owlDateTime]="start_date_picker" placeholder="Birth Date">
                                                   </app-form-field>
                                                   <owl-date-time #start_date_picker pickerType="calendar"></owl-date-time>
                                                </div>
                                                <div class="checkout-address-box-btn">
                                                   <button type="submit">Assign</button>
                                                </div>
                                             </div>
                                          </form>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>

                  </div>
               </div>
            </div>
            <div class="checkout-center-detail-right">
               <div class="checkout-center-detail-right-inner">
                  <h2>Bookings Summary</h2>
                  <div class="checkout-center-detail-right-general-admission">
                     <div class="checkout-center-detail-full">
                        <div class="checkout-center-detail-code">
                           <div class="checkout-center-detail-code-voucher">
                              <a (click)="apply_vourcher()" class="apply">Apply voucher</a>
                           </div>
                           <div class="course-final-apply-voucher-box left-box">
                              <input type="text" placeholder="Enter Code" (keydown.enter)="apply_vourcher()"
                                 id="promo_code">
                              <a href="javascript:void(0);" class="correct">
                                 <span class="right">
                                    <img src="assets/images/correct-shop.png">
                                 </span></a>
                              <a (click)="clearcode()" class="wrong">
                                 <span class="right">
                                    <img src="assets/images/cross.svg">
                                 </span></a>
                           </div>
                        </div>
                        <div class="apply_message"></div>
                     </div>
                     <div class="checkout-center-detail-payment">
                        <div class="checkout-center-detail-payment-total">
                           <div class="checkout-payment-total">
                              <div class="checkout-payment-total-text">Total</div>
                              <div class="checkout-payment-total-price">£{{subTotal}}.00</div>
                           </div>
                           <div class="checkout-payment-discount">
                              <div class="checkout-payment-discount-text">Order Discount</div>
                              <div class="checkout-payment-discount-price">£{{discount_amount}}.00</div>
                           </div>
                        </div>
                        <div class="checkout-payment-payable">
                           <div class="checkout-payment-payable-text">Payable Amount</div>
                           <div class="checkout-payment-payable-price">£{{grandTotal}}.00</div>
                        </div>
                        <div class="ashton-hero-top-payment-right checkout-payment">
                           <h3><span class="add-titel">Select Card</span> <span class="add-new"><a
                                    (click)="card_or_add()">Add new</a></span></h3>
                           <div class="ashton-hero-top-payment-add-card-detail">
                              <form #cardForm="ngForm" (ngSubmit)="addCard(cardForm)">
                                 <http-message types="success" [data]="cardSuccess" class="err-msg-block">
                                 </http-message>
                                 <http-message [type]="'error'" [data]="cardError" *ngIf="cardError"
                                    class="err-msg-block"></http-message>
                                 <div class="checkout-address-box full">
                                    <app-form-field validation="required" name="name" [(ngModel)]="cardRequest.name"
                                       class="app-group">
                                       <input appFieldInput type="text" name="" placeholder="Card Holder Name"
                                          class="input-style">
                                    </app-form-field>
                                 </div>
                                 <div class="checkout-address-box full">
                                    <app-form-field validation="required" name="number" [(ngModel)]="cardRequest.number"
                                       class="app-group">
                                       <input appFieldInput type="text" name="" placeholder="Card Number"
                                          class="input-style">
                                    </app-form-field>
                                 </div>
                                 <div class="checkout-address-box half mr">
                                    <app-form-field validation="required" name="exp_month"
                                       [(ngModel)]="cardRequest.exp_month" class="app-group">
                                       <input appFieldInput type="text" name="" placeholder="Exp Month"
                                          class="input-style">
                                    </app-form-field>
                                 </div>
                                 <div class="checkout-address-box half">
                                    <app-form-field validation="required" name="exp_year"
                                       [(ngModel)]="cardRequest.exp_year" class="app-group">
                                       <input appFieldInput type="text" name="" placeholder="Exp Year"
                                          class="input-style">
                                    </app-form-field>
                                 </div>
                                 <div class="checkout-address-box full">
                                    <app-form-field validation="required" name="cvc" [(ngModel)]="cardRequest.cvc"
                                       class="app-group">
                                       <input appFieldInput type="text" name="" placeholder="CVC" class="input-style">
                                    </app-form-field>
                                 </div>
                                 <div class="signup-btn ashton-signup-form-btn">
                                    <button type="submit">Submit</button>
                                 </div>
                              </form>
                           </div>
                           <div class="checkout-center-detail-add-box">
                              <http-message [type]="'error'" [data]="cardloadError" *ngIf="cardloadError"
                                 class="err-msg-block"></http-message>

                              <div class="checkout-center-detail-address-content" *ngFor="let card of cardList"  (click)="selectcard(card?.id, card?.customer)">
                                 <h3>{{card?.name}}</h3>
                                 <p>**** **** **** {{card?.last4}}</p>
                                 <div class="show-your-support-right-content-checkbox add-card-check-box">
                                    <label class="container-check">
                                       <input type="checkbox" id="cid-{{card?.id}}"
                                         >
                                       <span class="checkmark"></span>
                                    </label>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="checkout-payment-payable-btn">
                           <a (click)="confirm_pay()">Confirm & Pay</a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="want-to-buy-season-tickets-section cf">
            <div class="want-to-buy-season-tickets-left">
               <h3>Want to buy Season Tickets?</h3>
            </div>
            <div class="want-to-buy-season-tickets-right">
               <div class="want-to-buy-season-tickets-right-image">
                  <img src="assets/images/season-tickets.svg">
               </div>
            </div>
         </div>
      </div>
   </div>
</section>